// Mock scan data for the in-page app preview (made-up brands on purpose).

export const scanDemo = {
  steps: [
    { key: "scan", label: "Scan" },
    { key: "result", label: "Result" },
    { key: "swap", label: "Cleaner swap" },
  ],
  products: [
    {
      id: "soda",
      name: "Fizzwell Citrus Soda",
      size: "355 ml can",
      emoji: null,
      score: 41,
      verdict: "Use sparingly",
      tone: "warn",
      barcode: "0 48211 90341 7",
      flags: [
        {
          name: "High-fructose corn syrup",
          level: "high",
          why: "39 g added sugar per can \u2014 78% of the daily limit.",
          source: "USDA FoodData Central \u00b7 Mar 2026",
        },
        {
          name: "Yellow 5 (tartrazine)",
          level: "med",
          why: "Colour only. Linked to hyperactivity in sensitive children.",
          source: "FDA colour additive listing \u00b7 2025",
        },
        {
          name: "Citric acid",
          level: "low",
          why: "Common acidulant. No concern at this level.",
          source: "Open Food Facts \u00b7 Jan 2026",
        },
      ],
      swap: {
        name: "Bright Basin Sparkling Citrus",
        score: 88,
        reason:
          "Same shelf, no added sugar and no synthetic colour \u2014 just carbonated water and citrus juice.",
        wins: ["0 g added sugar", "No synthetic dyes", "3 ingredients"],
      },
    },
    {
      id: "cereal",
      name: "Morning Oat Crunch",
      size: "420 g box",
      score: 63,
      verdict: "Decent pick",
      tone: "mid",
      barcode: "0 71620 30188 2",
      flags: [
        {
          name: "Whole grain oats",
          level: "low",
          why: "First ingredient by weight. 4 g fibre per serving.",
          source: "USDA FoodData Central \u00b7 Feb 2026",
        },
        {
          name: "Cane sugar",
          level: "med",
          why: "9 g per serving \u2014 mid-range for a breakfast cereal.",
          source: "Manufacturer label \u00b7 Dec 2025",
        },
        {
          name: "BHT (in packaging)",
          level: "med",
          why: "Preservative in the liner. We could not verify the amount, so we say so.",
          source: "Unverified \u00b7 brand record missing",
        },
      ],
      swap: {
        name: "Field & Flake Plain Oats",
        score: 92,
        reason:
          "Cheaper per serving, one ingredient, and no packaging preservative on record.",
        wins: ["1 ingredient", "No added sugar", "No BHT on record"],
      },
    },
    {
      id: "sunscreen",
      name: "DayVeil Mineral SPF 40",
      size: "50 ml tube",
      score: 76,
      verdict: "Good for sensitive skin",
      tone: "good",
      barcode: "0 39418 77213 5",
      flags: [
        {
          name: "Zinc oxide 18%",
          level: "low",
          why: "Mineral UV filter. Broad spectrum, low irritation risk.",
          source: "FDA sunscreen monograph \u00b7 2025",
        },
        {
          name: "Fragrance (parfum)",
          level: "med",
          why: "Undisclosed blend \u2014 flagged because you listed fragrance sensitivity.",
          source: "Your profile \u00b7 skin concerns",
        },
        {
          name: "Squalane",
          level: "low",
          why: "Plant-derived emollient. Non-comedogenic.",
          source: "Brand record \u00b7 Nov 2025",
        },
      ],
      swap: {
        name: "Quiet Coast Mineral SPF 40",
        score: 94,
        reason:
          "Identical zinc oxide filter, fragrance-free, and on the same shelf for a dollar less.",
        wins: ["Fragrance-free", "Same SPF 40", "Reef-safe filters"],
      },
    },
  ],
};

export const previewCopy = {
  eyebrow: "How it works",
  title: "Shopping Just Got Smarter",
  sub:
    "Build Your List \u2014 plan your shopping trip before you leave the house. Add groceries, supplements, or beauty products all in one place. Then tap the middle phone to run a sample scan.",
  note: "Sample products, made-up brands. Real scans use live public records.",
};
